;; Copyright (C) 2017-2019, Doctor Evidence. All rights reserved.

(ns dre.shared.interface.article.tags
  "Article tags."
  {:authors ["Jozef Wagner"]}
  (:require
   [dre.coll :refer [map-by]]))


;;; Gender

(def female-terms
  #{"http://vocab.drevidence.com/DocSearch#Female"
    })

(def male-terms
  #{"http://vocab.drevidence.com/DocSearch#Male"})

(def gender-map
  (merge (zipmap female-terms (repeat :gender/female))
         (zipmap male-terms (repeat :gender/male))))

;;; Age

(def in-utero-terms
  #{"http://vocab.drevidence.com/DocSearch#InUtero"})

(def newborn-terms
  #{"http://vocab.drevidence.com/DocSearch#Newborn"})

(def infant-terms
  #{"http://vocab.drevidence.com/DocSearch#Infant"})

(def child-terms
  #{"http://vocab.drevidence.com/DocSearch#Child"})

(def adolescent-terms
  #{"http://vocab.drevidence.com/DocSearch#Adolescent"})

(def adult-terms
  #{"http://vocab.drevidence.com/DocSearch#Adult"})

(def young-adult-terms
  #{"http://vocab.drevidence.com/DocSearch#YoungAdult"})

(def elderly-terms
  #{"http://vocab.drevidence.com/DocSearch#Elderly"})

(def age-map
  (merge (zipmap in-utero-terms (repeat :age/in-utero))
         (zipmap newborn-terms (repeat :age/newborn))
         (zipmap infant-terms (repeat :age/infant))
         (zipmap child-terms (repeat :age/child))
         (zipmap adolescent-terms (repeat :age/adolescent))
         (zipmap adult-terms (repeat :age/adult))
         (zipmap young-adult-terms (repeat :age/adult))
         (zipmap elderly-terms (repeat :age/elderly))))

;;; Country

(def states
  ["http://vocab.drevidence.com/UMLS#C0027951"
   "http://vocab.drevidence.com/UMLS#C0039711"
   "http://vocab.drevidence.com/UMLS#C0003787"
   "http://vocab.drevidence.com/UMLS#C0022037"
   "http://vocab.drevidence.com/UMLS#C0022557"
   "http://vocab.drevidence.com/UMLS#C0025939"
   "http://vocab.drevidence.com/UMLS#C0016253"
   "http://vocab.drevidence.com/UMLS#C0001895"
   "http://vocab.drevidence.com/UMLS#C0027972"
   "http://vocab.drevidence.com/UMLS#C0024858"
   "http://vocab.drevidence.com/UMLS#C0037716"
   "http://vocab.drevidence.com/UMLS#C0028914"
   "http://vocab.drevidence.com/UMLS#C0037717"
   "http://vocab.drevidence.com/UMLS#C0024024"
   "http://vocab.drevidence.com/UMLS#C0009778"
   "http://vocab.drevidence.com/UMLS#C0027976"
   "http://vocab.drevidence.com/UMLS#C0017452"
   "http://vocab.drevidence.com/UMLS#C0028905"
   "http://vocab.drevidence.com/UMLS#C0024874"
   "http://vocab.drevidence.com/UMLS#C0043193"
   "http://vocab.drevidence.com/UMLS#C0018619"
   "http://vocab.drevidence.com/UMLS#C0022497"
   "http://vocab.drevidence.com/UMLS#C0043287"
   "http://vocab.drevidence.com/UMLS#C0027523"
   "http://vocab.drevidence.com/UMLS#C0030853"
   "http://vocab.drevidence.com/UMLS#C0028408"
   "http://vocab.drevidence.com/UMLS#C0006754"
   "http://vocab.drevidence.com/UMLS#C0020787"
   "http://vocab.drevidence.com/UMLS#C0028407"
   "http://vocab.drevidence.com/UMLS#C0026183"
   "http://vocab.drevidence.com/UMLS#C0042537"
   "http://vocab.drevidence.com/UMLS#C0009399"
   "http://vocab.drevidence.com/UMLS#C0042753"
   "http://vocab.drevidence.com/UMLS#C0001905"
   "http://vocab.drevidence.com/UMLS#C0042124"
   "http://vocab.drevidence.com/UMLS#C0027971"
   "http://vocab.drevidence.com/UMLS#C0039514"
   "http://vocab.drevidence.com/UMLS#C0026222"
   "http://vocab.drevidence.com/UMLS#C0024497"
   "http://vocab.drevidence.com/UMLS#C0020898"
   "http://vocab.drevidence.com/UMLS#C0026506"
   "http://vocab.drevidence.com/UMLS#C0011198"
   "http://vocab.drevidence.com/UMLS#C0029195"
   "http://vocab.drevidence.com/UMLS#C0027969"
   "http://vocab.drevidence.com/UMLS#C0021206"
   "http://vocab.drevidence.com/UMLS#C0003790"
   "http://vocab.drevidence.com/UMLS#C0043127"
   "http://vocab.drevidence.com/UMLS#C0026221"
   "http://vocab.drevidence.com/UMLS#C0043038"
   "http://vocab.drevidence.com/UMLS#C0035487"])

(def us-map
  (zipmap states (repeat :country/USA)))

(def country-map
  {"http://vocab.drevidence.com/UMLS#C0026514" :country/MSR,
 "http://vocab.drevidence.com/UMLS#C0018367" :country/GTM,
 "http://vocab.drevidence.com/UMLS#C0024943" :country/MRT,
 "http://vocab.drevidence.com/UMLS#C0004732" :country/BGD,
 "http://vocab.drevidence.com/UMLS#C0010306" :country/GRC,
 "http://vocab.drevidence.com/UMLS#C0042752" :country/VIR,
 "http://vocab.drevidence.com/UMLS#C0020822" :country/MAR,
 "http://vocab.drevidence.com/UMLS#C0042321" :country/VUT,
 "http://vocab.drevidence.com/UMLS#C0022065" :country/IRN,
 "http://vocab.drevidence.com/UMLS#C0018232" :country/GRD,
 "http://vocab.drevidence.com/UMLS#C0011318" :country/DNK,
 "http://vocab.drevidence.com/UMLS#C0021201" :country/IND,
 "http://vocab.drevidence.com/UMLS#C0018229" :country/GRL,
 "http://vocab.drevidence.com/UMLS#C0454831" :country/FRA,
 "http://vocab.drevidence.com/UMLS#C0026510" :country/MNE,
 "http://vocab.drevidence.com/UMLS#C0205830" :country/MYS,
 "http://vocab.drevidence.com/UMLS#C0009738" :country/COG,
 "http://vocab.drevidence.com/UMLS#C0086929" :country/GNQ,
 "http://vocab.drevidence.com/UMLS#C0042113" :country/URY,
 "http://vocab.drevidence.com/UMLS#C0036919" :country/SYC,
 "http://vocab.drevidence.com/UMLS#C0524613" :country/HKG,
 "http://vocab.drevidence.com/UMLS#C0039138" :country/SYR,
 "http://vocab.drevidence.com/UMLS#C0019905" :country/HND,
 "http://vocab.drevidence.com/UMLS#C4706217" :country/IDN,
 "http://vocab.drevidence.com/UMLS#C0022418" :country/JOR,
 "http://vocab.drevidence.com/UMLS#C0040237" :country/IDN,
 "http://vocab.drevidence.com/UMLS#C0039725" :country/THA,
 "http://vocab.drevidence.com/UMLS#C0002037" :country/DZA,
 "http://vocab.drevidence.com/UMLS#C0006893" :country/CPV,
 "http://vocab.drevidence.com/UMLS#C1519428" :country/SGS,
 "http://vocab.drevidence.com/UMLS#C0043402" :country/YEM,
 "http://vocab.drevidence.com/UMLS#C0037640" :country/SOM,
 "http://vocab.drevidence.com/UMLS#C0041580" :country/UKR,
 "http://vocab.drevidence.com/UMLS#C0037623" :country/SLB,
 "http://vocab.drevidence.com/UMLS#C0026544" :country/MAR,
 "http://vocab.drevidence.com/UMLS#C0014716" :country/ERI,
 "http://vocab.drevidence.com/UMLS#C0030428" :country/PRY,
 "http://vocab.drevidence.com/UMLS#C0454822" :country/ESP,
 "http://vocab.drevidence.com/UMLS#C0037712" :country/ZAF,
 "http://vocab.drevidence.com/UMLS#C0006888" :country/AUS,
 "http://vocab.drevidence.com/UMLS#C0206579" :country/SVK,
 "http://vocab.drevidence.com/UMLS#C0017454" :country/GEO,
 "http://vocab.drevidence.com/UMLS#C0041400" :country/TUR,
 "http://vocab.drevidence.com/UMLS#C0006797" :country/KHM,
 "http://vocab.drevidence.com/UMLS#C1519796" :country/UMI,
 "http://vocab.drevidence.com/UMLS#C0524612" :country/HKG,
 "http://vocab.drevidence.com/UMLS#C0023034" :country/LAO,
 "http://vocab.drevidence.com/UMLS#C0041698" :country/ARE,
 "http://vocab.drevidence.com/UMLS#C0003798" :country/ARM,
 "http://vocab.drevidence.com/UMLS#C0005126" :country/BMU,
 "http://vocab.drevidence.com/UMLS#C0015024" :country/ETH,
 "http://vocab.drevidence.com/UMLS#C0022341" :country/JPN,
 "http://vocab.drevidence.com/UMLS#C0028074" :country/NER,
 "http://vocab.drevidence.com/UMLS#C0039247" :country/TJK,
 "http://vocab.drevidence.com/UMLS#C0018309" :country/GUM,
 "http://vocab.drevidence.com/UMLS#C0028411" :country/VNM,
 "http://vocab.drevidence.com/UMLS#C0001732" :country/AFG,
 "http://vocab.drevidence.com/UMLS#C0037334" :country/SVN,
 "http://vocab.drevidence.com/UMLS#C0036708" :country/SRB,
 "http://vocab.drevidence.com/UMLS#C0043476" :country/ZWE,
 "http://vocab.drevidence.com/UMLS#C0454662" :country/ESP,
 "http://vocab.drevidence.com/UMLS#C0022537" :country/KAZ,
 "http://vocab.drevidence.com/UMLS#C0016080" :country/FJI,
 "http://vocab.drevidence.com/UMLS#C0205801" :country/MDV,
 "http://vocab.drevidence.com/UMLS#C2930714" :country/BLR,
 "http://vocab.drevidence.com/UMLS#C0004486" :country/AZE,
 "http://vocab.drevidence.com/UMLS#C0028075" :country/NGA,
 "http://vocab.drevidence.com/UMLS#C0030375" :country/PNG,
 "http://vocab.drevidence.com/UMLS#C0041388" :country/TUN,
 "http://vocab.drevidence.com/UMLS#C0022337" :country/JAM,
 "http://vocab.drevidence.com/UMLS#C0026374" :country/MDA,
 "http://vocab.drevidence.com/UMLS#C0024403" :country/MAC,
 "http://vocab.drevidence.com/UMLS#C0037063" :country/SLE,
 "http://vocab.drevidence.com/UMLS#C0022558" :country/KEN,
 "http://vocab.drevidence.com/UMLS#C0041573" :country/UGA,
 "http://vocab.drevidence.com/UMLS#C0015541" :country/FRO,
 "http://vocab.drevidence.com/UMLS#C0030266" :country/PAN,
 "http://vocab.drevidence.com/UMLS#C0006041" :country/BWA,
 "http://vocab.drevidence.com/UMLS#C0042469" :country/VEN,
 "http://vocab.drevidence.com/UMLS#C0007928" :country/TCD,
 "http://vocab.drevidence.com/UMLS#C0037186" :country/CHN,
 "http://vocab.drevidence.com/UMLS#C0024443" :country/MDG,
 "http://vocab.drevidence.com/UMLS#C1518860" :country/PSE,
 "http://vocab.drevidence.com/UMLS#C0021204" :country/MDV,
 "http://vocab.drevidence.com/UMLS#C0024444" :country/PRT,
 "http://vocab.drevidence.com/UMLS#C0008107" :country/CHL,
 "http://vocab.drevidence.com/UMLS#C0022277" :country/ITA,
 "http://vocab.drevidence.com/UMLS#C0005005" :country/BEN,
 "http://vocab.drevidence.com/UMLS#C0023634" :country/LBY,
 "http://vocab.drevidence.com/UMLS#C0018301" :country/GLP,
 "http://vocab.drevidence.com/UMLS#C0026405" :country/MCO,
 "http://vocab.drevidence.com/UMLS#C0016910" :country/GAB,
 "http://vocab.drevidence.com/UMLS#C0027779" :country/XNN,
 "http://vocab.drevidence.com/UMLS#C0018223" :country/GBR,
 "http://vocab.drevidence.com/UMLS#C0020174" :country/HUN,
 "http://vocab.drevidence.com/UMLS#C0036232" :country/ITA,
 "http://vocab.drevidence.com/UMLS#C0242397" :country/PLW,
 "http://vocab.drevidence.com/UMLS#C0039298" :country/TZA,
 "http://vocab.drevidence.com/UMLS#C0018381" :country/GIN,
 "http://vocab.drevidence.com/UMLS#C0026655" :country/MOZ,
 "http://vocab.drevidence.com/UMLS#C0024581" :country/MLI,
 "http://vocab.drevidence.com/UMLS#C0087007" :country/YEM,
 "http://vocab.drevidence.com/UMLS#C0031529" :country/PHL,
 "http://vocab.drevidence.com/UMLS#C0454738" :country/IDN,
 "http://vocab.drevidence.com/UMLS#C0026410" :country/MNG,
 "http://vocab.drevidence.com/UMLS#C0206001" :country/YEM,
 "http://vocab.drevidence.com/UMLS#C0031238" :country/PER,
 "http://vocab.drevidence.com/UMLS#C0042177" :country/UZB,
 "http://vocab.drevidence.com/UMLS#C0006802" :country/CMR,
 "http://vocab.drevidence.com/UMLS#C0001993" :country/JEY,
 "http://vocab.drevidence.com/UMLS#C0282244" :country/FSM,
 "http://vocab.drevidence.com/UMLS#C0026001" :country/FSM,
 "http://vocab.drevidence.com/UMLS#C0002838" :country/AND,
 "http://vocab.drevidence.com/UMLS#C0041703" :country/USA,
 "http://vocab.drevidence.com/UMLS#C0034366" :country/QAT,
 "http://vocab.drevidence.com/UMLS#C0035970" :country/RUS,
 "http://vocab.drevidence.com/UMLS#C0012836" :country/DJI,
 "http://vocab.drevidence.com/UMLS#C0042427" :country/VAT,
 "http://vocab.drevidence.com/UMLS#C0039260" :country/TWN,
 "http://vocab.drevidence.com/UMLS#C0024548" :country/MWI,
 "http://vocab.drevidence.com/UMLS#C0038642" :country/SDN,
 "http://vocab.drevidence.com/UMLS#C0004340" :country/AUS,
 "http://vocab.drevidence.com/UMLS#C0206006" :country/COD,
 "http://vocab.drevidence.com/UMLS#C0005341" :country/BTN,
 "http://vocab.drevidence.com/UMLS#C0006823" :country/CAN,
 "http://vocab.drevidence.com/UMLS#C0018408" :country/GUY,
 "http://vocab.drevidence.com/UMLS#C0014651" :country/GNQ,
 "http://vocab.drevidence.com/UMLS#C0018387" :country/GNB,
 "http://vocab.drevidence.com/UMLS#C0004684" :country/BHR,
 "http://vocab.drevidence.com/UMLS#C0041700" :country/GBR,
 "http://vocab.drevidence.com/UMLS#C0524501" :country/BWA,
 "http://vocab.drevidence.com/UMLS#C0001909" :country/ALB,
 "http://vocab.drevidence.com/UMLS#C0032729" :country/PRT,
 "http://vocab.drevidence.com/UMLS#C0010622" :country/CYP,
 "http://vocab.drevidence.com/UMLS#C0010435" :country/CUB,
 "http://vocab.drevidence.com/UMLS#C0010343" :country/HRV,
 "http://vocab.drevidence.com/UMLS#C0024653" :country/MLT,
 "http://vocab.drevidence.com/UMLS#C0030211" :country/PAK,
 "http://vocab.drevidence.com/UMLS#C0041403" :country/TKM,
 "http://vocab.drevidence.com/UMLS#C0027964" :country/NCL,
 "http://vocab.drevidence.com/UMLS#C0008115" :country/CHN,
 "http://vocab.drevidence.com/UMLS#C0206004" :country/MKD,
 "http://vocab.drevidence.com/UMLS#C0036183" :country/STP,
 "http://vocab.drevidence.com/UMLS#C0016703" :country/GUF,
 "http://vocab.drevidence.com/UMLS#C0039021" :country/CHE,
 "http://vocab.drevidence.com/UMLS#C0038944" :country/SUR,
 "http://vocab.drevidence.com/UMLS#C0009490" :country/COM,
 "http://vocab.drevidence.com/UMLS#C0019907" :country/HKG,
 "http://vocab.drevidence.com/UMLS#C0018510" :country/HTI,
 "http://vocab.drevidence.com/UMLS#C0025885" :country/MEX,
 "http://vocab.drevidence.com/UMLS#C0038995" :country/SWE,
 "http://vocab.drevidence.com/UMLS#C0043444" :country/COD,
 "http://vocab.drevidence.com/UMLS#C0024853" :country/MTQ,
 "http://vocab.drevidence.com/UMLS#C0023190" :country/LBN,
 "http://vocab.drevidence.com/UMLS#C0006409" :country/BFA,
 "http://vocab.drevidence.com/UMLS#C0600207" :country/EGY,
 "http://vocab.drevidence.com/UMLS#C0024553" :country/MDV,
 "http://vocab.drevidence.com/UMLS#C0017480" :country/DEU,
 "http://vocab.drevidence.com/UMLS#C0006368" :country/BGR,
 "http://vocab.drevidence.com/UMLS#C1517317" :country/ATF,
 "http://vocab.drevidence.com/UMLS#C0016968" :country/ECU,
 "http://vocab.drevidence.com/UMLS#C0004348" :country/AUT,
 "http://vocab.drevidence.com/UMLS#C0016674" :country/FRA,
 "http://vocab.drevidence.com/UMLS#C0007673" :country/CAF,
 "http://vocab.drevidence.com/UMLS#C0020750" :country/ISL,
 "http://vocab.drevidence.com/UMLS#C0022132" :country/IMN,
 "http://vocab.drevidence.com/UMLS#C0035373" :country/REU,
 "http://vocab.drevidence.com/UMLS#C0205712" :country/JEY,
 "http://vocab.drevidence.com/UMLS#C0016704" :country/PYF,
 "http://vocab.drevidence.com/UMLS#C3245499" :country/COL,
 "http://vocab.drevidence.com/UMLS#C0024944" :country/MUS,
 "http://vocab.drevidence.com/UMLS#C0009212" :country/MDV,
 "http://vocab.drevidence.com/UMLS#C0205773" :country/GRC,
 "http://vocab.drevidence.com/UMLS#C0028423" :country/NOR,
 "http://vocab.drevidence.com/UMLS#C0006539" :country/BLR,
 "http://vocab.drevidence.com/UMLS#C0042658" :country/VNM,
 "http://vocab.drevidence.com/UMLS#C0024683" :country/CHN,
 "http://vocab.drevidence.com/UMLS#C0031187" :country/IRN,
 "http://vocab.drevidence.com/UMLS#C0022773" :country/KOR,
 "http://vocab.drevidence.com/UMLS#C0023128" :country/LVA,
 "http://vocab.drevidence.com/UMLS#C0028971" :country/OMN,
 "http://vocab.drevidence.com/UMLS#C0027689" :country/NPL,
 "http://vocab.drevidence.com/UMLS#C0021247" :country/IDN,
 "http://vocab.drevidence.com/UMLS#C0017516" :country/GHA,
 "http://vocab.drevidence.com/UMLS#C0043436" :country/FRY,
 "http://vocab.drevidence.com/UMLS#C0003761" :country/ARG,
 "http://vocab.drevidence.com/UMLS#C0205804" :country/IDN,
 "http://vocab.drevidence.com/UMLS#C0028002" :country/NIC,
 "http://vocab.drevidence.com/UMLS#C0038111" :country/FRA,
 "http://vocab.drevidence.com/UMLS#C0022804" :country/KWT,
 "http://vocab.drevidence.com/UMLS#C0038983" :country/SWZ,
 "http://vocab.drevidence.com/UMLS#C0023879" :country/LTU,
 "http://vocab.drevidence.com/UMLS#C0018370" :country/GGY,
 "http://vocab.drevidence.com/UMLS#C0036243" :country/SAU,
 "http://vocab.drevidence.com/UMLS#C0036196" :country/MYS,
 "http://vocab.drevidence.com/UMLS#C0206003" :country/XKS,
 "http://vocab.drevidence.com/UMLS#C0022718" :country/KGZ,
 "http://vocab.drevidence.com/UMLS#C0005984" :country/JPN,
 "http://vocab.drevidence.com/UMLS#C0036154" :country/SMR,
 "http://vocab.drevidence.com/UMLS#C0037173" :country/SGP,
 "http://vocab.drevidence.com/UMLS#C1452561" :country/TLS,
 "http://vocab.drevidence.com/UMLS#C0001766" :country/MUS,
 "http://vocab.drevidence.com/UMLS#C0038088" :country/LKA,
 "http://vocab.drevidence.com/UMLS#C0027496" :country/NRU,
 "http://vocab.drevidence.com/UMLS#C0013715" :country/EGY,
 "http://vocab.drevidence.com/UMLS#C0005918" :country/BOL,
 "http://vocab.drevidence.com/UMLS#C0013754" :country/SLV,
 "http://vocab.drevidence.com/UMLS#C0006320" :country/BRN,
 "http://vocab.drevidence.com/UMLS#C0013593" :country/ECU,
 "http://vocab.drevidence.com/UMLS#C0032356" :country/POL,
 "http://vocab.drevidence.com/UMLS#C0043445" :country/ZMB,
 "http://vocab.drevidence.com/UMLS#C0006137" :country/BRA,
 "http://vocab.drevidence.com/UMLS#C0027978" :country/NZL,
 "http://vocab.drevidence.com/UMLS#C0027778" :country/NLD,
 "http://vocab.drevidence.com/UMLS#C0041061" :country/TTO,
 "http://vocab.drevidence.com/UMLS#C0006448" :country/BDI,
 "http://vocab.drevidence.com/UMLS#C0205803" :country/IDN,
 "http://vocab.drevidence.com/UMLS#C0023668" :country/LIE,
 "http://vocab.drevidence.com/UMLS#C0007481" :country/CYM,
 "http://vocab.drevidence.com/UMLS#C0004950" :country/BEL,
 "http://vocab.drevidence.com/UMLS#C0036056" :country/LCA,
 "http://vocab.drevidence.com/UMLS#C0282379" :country/ABW,
 "http://vocab.drevidence.com/UMLS#C0022772" :country/PRK,
 "http://vocab.drevidence.com/UMLS#C0205829" :country/MYS,
 "http://vocab.drevidence.com/UMLS#C0004166" :country/STP,
 "http://vocab.drevidence.com/UMLS#C0205805" :country/IDN,
 "http://vocab.drevidence.com/UMLS#C0349396" :country/FLK,
 "http://vocab.drevidence.com/UMLS#C0040363" :country/TGO,
 "http://vocab.drevidence.com/UMLS#C0022066" :country/IRQ,
 "http://vocab.drevidence.com/UMLS#C0023376" :country/LSO,
 "http://vocab.drevidence.com/UMLS#C0006036" :country/BIH,
 "http://vocab.drevidence.com/UMLS#C0038108" :country/SHN,
 "http://vocab.drevidence.com/UMLS#C0024176" :country/LUX,
 "http://vocab.drevidence.com/UMLS#C0013014" :country/DOM,
 "http://vocab.drevidence.com/UMLS#C0024552" :country/MYS,
 "http://vocab.drevidence.com/UMLS#C0021249" :country/IDN,
 "http://vocab.drevidence.com/UMLS#C0016993" :country/GMB,
 "http://vocab.drevidence.com/UMLS#C0021515" :country/CHN,
 "http://vocab.drevidence.com/UMLS#C0034044" :country/PRI,
 "http://vocab.drevidence.com/UMLS#C0017540" :country/GIB,
 "http://vocab.drevidence.com/UMLS#C0035978" :country/RWA,
 "http://vocab.drevidence.com/UMLS#C0018226" :country/GRC,
 "http://vocab.drevidence.com/UMLS#C0206578" :country/CZE,
 "http://vocab.drevidence.com/UMLS#C0282380" :country/KNA,
 "http://vocab.drevidence.com/UMLS#C0027366" :country/NAM,
 "http://vocab.drevidence.com/UMLS#C0006196" :country/IOT,
 "http://vocab.drevidence.com/UMLS#C0022271" :country/ISR,
 "http://vocab.drevidence.com/UMLS#C0037747" :country/ESP,
 "http://vocab.drevidence.com/UMLS#C0454673" :country/JEY,
 "http://vocab.drevidence.com/UMLS#C0376188" :country/IDN,
 "http://vocab.drevidence.com/UMLS#C0035826" :country/ROU,
 "http://vocab.drevidence.com/UMLS#C0036644" :country/SEN,
 "http://vocab.drevidence.com/UMLS#C0014908" :country/EST,
 "http://vocab.drevidence.com/UMLS#C1515101" :country/SJM,
 "http://vocab.drevidence.com/UMLS#C0007950" :country/JEY,
 "http://vocab.drevidence.com/UMLS#C0023617" :country/LBR,
 "http://vocab.drevidence.com/UMLS#C0003023" :country/AGO,
 "http://vocab.drevidence.com/UMLS#C0010182" :country/CRI,
 "http://vocab.drevidence.com/UMLS#C0004683" :country/BHS,
 "http://vocab.drevidence.com/UMLS#C1520135" :country/ESH,
 "http://vocab.drevidence.com/UMLS#C0006416" :country/MMR,
 "http://vocab.drevidence.com/UMLS#C0039291" :country/TZA,
 "http://vocab.drevidence.com/UMLS#C1704740" :country/ALA,
 "http://vocab.drevidence.com/UMLS#C0024974" :country/MYT,
 "http://vocab.drevidence.com/UMLS#C0022067" :country/IRL,
 "http://vocab.drevidence.com/UMLS#C0242536" :country/ASM,
 "http://vocab.drevidence.com/UMLS#C1511278" :country/BVT,
 "http://vocab.drevidence.com/UMLS#C0016132" :country/FIN,
 "http://vocab.drevidence.com/UMLS#C0205959" :country/TZA,
 "http://vocab.drevidence.com/UMLS#C0004952" :country/BLZ,
 "http://vocab.drevidence.com/UMLS#C0001741" :country/IOT,
 "http://vocab.drevidence.com/UMLS#C0004739" :country/BRB,
 "http://vocab.drevidence.com/UMLS#C0003354" :country/ATG,
 "http://vocab.drevidence.com/UMLS#C0022326" :country/CIV,
 "http://vocab.drevidence.com/UMLS#C0017550" :country/KIR,
 "http://vocab.drevidence.com/UMLS#C0242537" :country/WSM,
 "http://vocab.drevidence.com/UMLS#C0041413" :country/TUV,
 "http://vocab.drevidence.com/UMLS#C3273373" :country/SSD,
 "http://vocab.drevidence.com/UMLS#C0036057" :country/VCT,
 "http://vocab.drevidence.com/UMLS#C0040407" :country/TON,
 "http://vocab.drevidence.com/UMLS#C0024851" :country/MHL})

(def country-sense-map-base
  {"SU0b" :country/ATG,
   "SUGEU" :country/MHL,
   "SU7Nq" :country/WSM,
   "SUJE2" :country/SGP,
   "SUE3E" :country/HKG,
   "SUBJ9" :country/BGD,
   "SUKm2" :country/ZMB,
   "SUGcH" :country/MDA,
   "SUFgK" :country/KAZ,
   "SUIY_" :country/QAT,
   "SUGFw" :country/MRT,
   "SUFc3" :country/CIV,
   "SUG1L" :country/NZL,
   "SUB75" :country/TCD,
   "SUGUe" :country/MEX,
   "SUKJt" :country/UKR,
   "SUEfO" :country/GIN,
   "SUyS0" :country/XKS,
   "SUJld" :country/TWN,
   "SUFn7" :country/LAO,
   "SUBea" :country/BWA,
   "SUKGt" :country/TUN,
   "SUGgg" :country/MOZ,
   "SUFMA" :country/IDN,
   "SUJ2U" :country/TTO,
   "SUKBm" :country/TTO,
   "SUESF" :country/GIB,
   "SUBOO" :country/BEN,
   "SUEFA" :country/GUF,
   "SUCw3" :country/DNK,
   "SUGyE" :country/XNN,
   "SUB-0" :country/CHN,
   "SUBGH" :country/AZE,
   "SUCYL" :country/COG,
   "SUFcG" :country/ITA,
   "SUF_l" :country/MWI,
   "SUFzC1" :country/UMI,
   "SUIzZ" :country/LCA,
   "SUE3C" :country/HND,
   "SUDUa" :country/ECU,
   "SUFxC" :country/LBR,
   "SU7Np" :country/ASM,
   "SUI9l" :country/SRB,
   "SUHYE" :country/PAK,
   "SUJNR" :country/ZAF,
   "SUKVS" :country/VUT,
   "SUKm1" :country/COD,
   "SUG09" :country/NCL,
   "SUFdG" :country/JPN,
   "SUJMJ" :country/SOM,
   "SUFy9F" :country/SGS,
   "SUHbd" :country/PRY,
   "SUFdC" :country/JAM,
   "SUJA4" :country/SYC,
   "SUHao" :country/PNG,
   "SUJN0" :country/ESP,
   "SUBNX" :country/BEL,
   "SUGAG" :country/MLI,
   "SUFxT" :country/LBY,
   "SUHsq" :country/PHL,
   "SUEfp" :country/GUY,
   "SUDk8" :country/GNQ,
   "SU7X" :country/ARM,
   "SUBqO" :country/KHM,
   "SUI2U" :country/SAU,
   "SUG2r" :country/NER,
   "SUDl9" :country/ERI,
   "SUD8F" :country/FIN,
   "SUyb0" :country/SVK,
   "SUFioS" :country/TLS,
   "SUCho" :country/HRV,
   "SUBeV" :country/BIH,
   "SUB06" :country/CYM,
   "SUKLl" :country/GBR,
   "SUEcw" :country/GBR,
   "SUDqx" :country/ETH,
   "SUBkR" :country/MMR,
   "SUDIl" :country/DJI,
   "SUF98" :country/MDG,
   "SU6y" :country/ARG,
   "SUB36" :country/CAF,
   "SUERJ" :country/DEU,
   "SUI8l" :country/SEN,
   "SUsX" :country/AND,
   "SUEQv" :country/GEO,
   "SUKJm" :country/UGA,
   "SUKW8" :country/VAT,
   "SUG8I" :country/NOR,
   "SUbF" :country/AFG,
   "SUIou" :country/REU,
   "SUKmt" :country/FRY,
   "SUFycG" :country/ATF,
   "SUIvz" :country/ROU,
   "SUKcB" :country/VIR,
   "SUDW7" :country/SLV,
   "SUBD9" :country/AUT,
   "SUybz" :country/CZE,
   "SUCUT" :country/MYT,
   "SUKaj" :country/VNM,
   "SUJL4" :country/SLB,
   "SUNg" :country/ARE,
   "SUKLj" :country/ARE,
   "SUGrn" :country/NAM,
   "SUJl8" :country/TZA,
   "SUJmD" :country/TZA,
   "SUBTe" :country/BTN,
   "SUFw9v" :country/BVT,
   "SUBqo" :country/CAN,
   "SUCfH" :country/CRI,
   "SUBQH" :country/BMU,
   "SUJhI" :country/SWZ,
   "SUJgh" :country/SUR,
   "SUEIP" :country/GAB,
   "SUDWU" :country/EGY,
   "SUGcm" :country/MCO,
   "SUEJi" :country/GMB,
   "SUFqX" :country/LBN,
   "SUFcA" :country/ISR,
   "SUCbl" :country/PYF,
   "SUKnV" :country/ZWE,
   "SUf2" :country/DZA,
   "SUF5x" :country/LUX,
   "SUG1j" :country/NIC,
   "SUEfA" :country/GTM,
   "SUFtR" :country/LSO,
   "SUEd-" :country/GLP,
   "SUCl_" :country/CYP,
   "SUJbz" :country/SDN,
   "SUERt" :country/GHA,
   "SUGyD" :country/NLD,
   "SUBVTV" :country/FLK,
   "SUE7P" :country/HUN,
   "SUGBO" :country/MLT,
   "SUBmM" :country/BLR,
   "SUJsu" :country/THA,
   "SUBJN" :country/BHR,
   "SUd2" :country/ALB,
   "SUBix" :country/BRN,
   "SUfK" :country/JEY,
   "SUJ2s" :country/TGO,
   "SUNNsS" :country/TGO,
   "SUGeP" :country/MNE,
   "SUyS1" :country/MKD,
   "SUEEj" :country/FRA,
   "SUBKE" :country/BRB,
   "SUFYz" :country/IRQ,
   "SUBqT" :country/CMR,
   "SUFLS" :country/IND,
   "SUG2s" :country/NGA,
   "SUB-s" :country/CHL,
   "SUMYW8" :country/COL,
   "SUKLo" :country/USA,
   "SUFYy" :country/IRN,
   "SUI07" :country/SMR,
   "SUIyL" :country/RWA,
   "SUJTJ" :country/LKA,
   "SUBE8M" :country/ABW,
   "SUBBH" :country/STP,
   "SUFEP" :country/ISL,
   "SUFkV" :country/KWT,
   "SUFpZ" :country/LVA,
   "SUFj1" :country/PRK,
   "SUbO" :country/IOT,
   "SUEhP" :country/HTI,
   "SUI1Y" :country/STP,
   "SUKXm" :country/VEN,
   "SUIyD" :country/RUS,
   "SUJhu" :country/CHE,
   "SUJlQ" :country/TJK,
   "SUJDI" :country/SLE,
   "SUBNZ" :country/BLZ,
   "SUBkK" :country/BFA,
   "SUEeG" :country/GUM,
   "SUBcf" :country/BOL,
   "SUbn" :country/MUS,
   "SUGFx" :country/MUS,
   "SUFy0N" :country/PSE,
   "SUD7R" :country/FJI,
   "SUV_" :country/YEM,
   "SUKmL" :country/YEM,
   "SUBD1" :country/AUS,
   "SUDLX" :country/DOM,
   "SUH5l" :country/POL,
   "SUBkx" :country/BDI,
   "SUJhU" :country/SWE,
   "SUKSC" :country/URY,
   "S1Gtp" :country/NRU,
   "SUEc5" :country/GRD,
   "SUF9U" :country/MAC,
   "SUBJM" :country/BHS,
   "SUKG8" :country/TKM,
   "SUFY0" :country/IRL,
   "SUFi_" :country/KGZ,
   "SUEfD" :country/GGY,
   "SUCjE" :country/CUB,
   "SUF_p" :country/MYS,
   "SUFx5e" :country/SJM,
   "SUvQ" :country/AGO,
   "SUJHX" :country/SVN,
   "SUFzII" :country/ESH,
   "SUBru" :country/CPV,
   "SUJjj" :country/SYR,
   "SUF1I" :country/LTU,
   "SUEfU" :country/GNB,
   "SUEc2" :country/GRL,
   "SUFj2" :country/KOR,
   "SUCP9" :country/MDV,
   "SUF_q" :country/MDV,
   "SUDo9" :country/EST,
   "SUGEW" :country/MTQ,
   "SU7Le" :country/PLW,
   "SUFgf" :country/KEN,
   "SUGwq" :country/NPL,
   "SUF99" :country/PRT,
   "SUH_a" :country/PRT,
   "SUFx1" :country/LIE,
   "SUChD" :country/GRC,
   "SUEcz" :country/GRC,
   "SUKG5" :country/TUR,
   "SUGcr" :country/MNG,
   "SUHEs" :country/OMN,
   "SUFFX" :country/MAR,
   "SUGex" :country/MAR,
   "SUHY7" :country/PAN,
   "SUBjh" :country/BGR,
   "SUIT9" :country/PRI,
   "SUBf6" :country/BRA,
   "SUKTC" :country/UZB,
   "SUHoH" :country/PER,
   "SUFeT" :country/JOR,
   "SUBE8N" :country/KNA,
   "S0ESP" :country/KIR,
   "SUKHG" :country/TUV,
   "SUMfKe" :country/SSD,
   "SUIza" :country/VCT,
   "SUGWS" :country/FSM,
   "S1J3Y" :country/TON,
   "SUEDji" :country/TON,
   "SUBE6F" :country/FSM
   "SUFZ1" :country/IMN})

;; generated with dre.annotator-client.tagger/generate-country-sense-map on 2023-04-13
(def country-sense-map-descendants
  {"SUFLX" :country/USA,
   "SUHDq" :country/USA,
   "SUJz3" :country/CHN,
   "SUKYq" :country/USA,
   "SUE3E" :country/CHN,
   "SUIqg" :country/USA,
   "SUGEb" :country/USA,
   "SUGEr" :country/USA,
   "SUGZu" :country/USA,
   "SUBvBt" :country/AUS,
   "SUFYW" :country/USA,
   "SUHiG" :country/USA,
   "SUJNb" :country/USA,
   "SUFge" :country/USA,
   "SUGeL" :country/USA,
   "SUKcC" :country/USA,
   "SUG8E" :country/USA,
   "SUKSN" :country/USA,
   "SUCAIT" :country/USA,
   "SUGCX" :country/CAN,
   "SUEDjt" :country/TON,
   "SUHsm" :country/USA,
   "SUEDjj" :country/TON,
   "SU7Np" :country/WSM,
   "SUKaW" :country/AUS,
   "SUIZY" :country/AUS,
   "SUG1I" :country/AUS,
   "SUJC2" :country/RUS,
   "SUB8P" :country/GBR,
   "SUGZI" :country/USA,
   "SUJDk" :country/IND,
   "SUG08" :country/CAN,
   "SUHIM" :country/USA,
   "SUD9-" :country/USA,
   "SUJMJ" :country/IOT,
   "SUDHd" :country/USA,
   "SUMvU2" :country/TGO,
   "SUF3Z" :country/USA,
   "SUJA4" :country/IOT,
   "SUG1E" :country/USA,
   "SUDfL" :country/GBR,
   "SUMfKe" :country/IOT,
   "SUFGj" :country/USA,
   "SUJmD" :country/IOT,
   "SUBeW" :country/USA,
   "SUG8B" :country/AUS,
   "SUJC6" :country/ITA,
   "SUHDz" :country/USA,
   "SUDl9" :country/IOT,
   "SUI934" :country/USA,
   "SUKh8" :country/WSM,
   "SUHY8" :country/PAN,
   "SUJNh" :country/USA,
   "SUJ20" :country/JPN,
   "SUDqx" :country/IOT,
   "SUDIl" :country/IOT,
   "SUF98" :country/IOT,
   "SUyOR" :country/GBR,
   "SUIGG" :country/CAN,
   "SUC3rY" :country/CAN,
   "SUKJm" :country/IOT,
   "SUG0w" :country/USA,
   "SU7M" :country/USA,
   "SUBGg" :country/STP,
   "SUJNW" :country/USA,
   "SU7P" :country/USA,
   "SUJpb" :country/USA,
   "SUKh4" :country/USA,
   "SUBgy" :country/CAN,
   "SUCUT" :country/IOT,
   "SUCq-" :country/RUS,
   "SUI2L" :country/CAN,
   "SUOr-n" :country/KOR,
   "SUHFx" :country/CAN,
   "SUBvAS" :country/GBR,
   "SUBQH" :country/STP,
   "SUKh5" :country/AUS,
   "SUGXG" :country/USA,
   "SUBpj" :country/USA,
   "SUEQt" :country/USA,
   "SUKi6" :country/USA,
   "SUKmv" :country/CAN,
   "SUN9Hd" :country/RUS,
   "SUGZv" :country/USA,
   "SU4a" :country/USA,
   "SUBvE2" :country/FLK,
   "SUJbz" :country/IOT,
   "SUEi8" :country/USA,
   "SUB9t" :country/USA,
   "SUIZX" :country/CAN,
   "SUBVTV" :country/STP,
   "SUBvE1" :country/FLK,
   "SUfK" :country/GBR,
   "SUdy" :country/USA,
   "SUFfi" :country/USA,
   "SUG74" :country/USA,
   "SUG0-" :country/USA,
   "SUCYz" :country/USA,
   "SUJmo" :country/AUS,
   "SUIyL" :country/IOT,
   "SUBE8M" :country/STP,
   "SUCu_" :country/USA,
   "SURL3c" :country/STP,
   "SUGuE" :country/USA,
   "SUEcx" :country/USA,
   "SUG8C" :country/CAN,
   "SUF2m" :country/GBR,
   "SUI05" :country/USA,
   "SUI1Y" :country/STP,
   "SUF-y" :country/USA,
   "SUJsg" :country/USA,
   "SUI5m" :country/GBR,
   "SUG1K" :country/USA,
   "SUHdi" :country/FRA,
   "SUJNV" :country/USA,
   "SUGfV" :country/RUS,
   "SUEeG" :country/FSM,
   "SUPbBR" :country/CHN,
   "SUGVU" :country/USA,
   "SUKkY" :country/USA,
   "SUKgf" :country/USA,
   "SUBkx" :country/IOT,
   "SUG1F" :country/USA,
   "SUCS4" :country/USA,
   "SUF9U" :country/CHN,
   "SUKgI" :country/GBR,
   "SUEmx" :country/GBR,
   "SUG8a" :country/CAN,
   "SUBQG" :country/DEU,
   "SUGXi" :country/USA,
   "SUEfD" :country/GBR,
   "SUdo" :country/USA,
   "SUG8A" :country/GBR,
   "SUG1J" :country/USA,
   "SUJhB" :country/NOR,
   "SUBLE" :country/RUS,
   "SUIv4" :country/ITA,
   "SUFE0" :country/USA,
   "SUBru" :country/STP,
   "SUEc2" :country/DNK,
   "SUBJt" :country/USA,
   "SU7Le" :country/FSM,
   "SUFgf" :country/IOT,
   "SUHdlX" :country/CAN,
   "SUd7" :country/CAN,
   "SUG75" :country/USA,
   "SUF3Q" :country/USA,
   "SUG1C" :country/USA,
   "SUJNU" :country/AUS})

(def country-sense-map
  (map-by (concat country-sense-map-descendants
                  country-sense-map-base)))

(def label-country-map
  {"northern mariana islands" :country/FSM,
   "mac" :country/MAC,
   "prt" :country/PRT,
   "nl" :country/NLD,
   "kor" :country/KOR,
   "aw" :country/ABW,
   "new guinea, papua" :country/PNG,
   "bl" :country/BOL,
   "zw" :country/ZWE,
   "virgin islands" :country/VIR,
   "pyf" :country/PYF,
   "åland islands" :country/ALA,
   "cod" :country/COD,
   "hti" :country/HTI,
   "iv" :country/CIV,
   "belgium" :country/BEL,
   "malaysia" :country/MYS,
   "dom" :country/DOM,
   "venezuela" :country/VEN,
   "us" :country/USA,
   "cg" :country/COD,
   "afghanistan" :country/AFG,
   "belize" :country/BLZ,
   "western sahara" :country/ESH,
   "ee" :country/EST,
   "australia" :country/AUS,
   "cameroon" :country/CMR,
   "islas malvinas" :country/FLK,
   "moldova" :country/MDA,
   "phl" :country/PHL,
   "venezuela, bolivian republic of" :country/VEN,
   "bwa" :country/BWA,
   "dza" :country/DZA,
   "bk" :country/BIH,
   "svn" :country/SVN,
   "im" :country/IMN,
   "pf" :country/PYF,
   "ct" :country/CAF,
   "byelarus" :country/BLR,
   "india" :country/IND,
   "japan" :country/JPN,
   "czechia" :country/CZE,
   "bermudas" :country/BMU,
   "ym" :country/YEM,
   "ec" :country/ECU,
   "suriname" :country/SUR,
   "lbr" :country/LBR,
   "bfa" :country/BFA,
   "st" :country/STP,
   "tobago" :country/TTO,
   "prk" :country/PRK,
   "slb" :country/SLB,
   "idn" :country/IDN,
   "gm" :country/DEU,
   "mkd" :country/MKD,
   "kh" :country/KHM,
   "saint helena, ascension and tristan da cunha" :country/SHN,
   "democratic republic of the congo" :country/COD,
   "td" :country/TTO,
   "xk" :country/XKS,
   "st. lucia" :country/LCA,
   "gin" :country/GIN,
   "nh" :country/VUT,
   "wi" :country/ESH,
   "tanzania, united republic of" :country/TZA,
   "republic of fiji" :country/FJI,
   "brn" :country/BRN,
   "bouvet island" :country/BVT,
   "pt" :country/PRT,
   "hk" :country/HKG,
   "british indian ocean territory" :country/IOT,
   "belarus" :country/BLR,
   "mne" :country/MNE,
   "bgr" :country/BGR,
   "en" :country/EST,
   "la" :country/LAO,
   "brazil" :country/BRA,
   "réunion" :country/REU,
   "iz" :country/IRQ,
   "marshall islands" :country/MHL,
   "sw" :country/SWE,
   "gambia" :country/GMB,
   "bdi" :country/BDI,
   "republic of finland" :country/FIN,
   "bz" :country/BLZ,
   "br" :country/BRA,
   "gilbert islands" :country/FSM,
   "rs" :country/SRB,
   "tun" :country/TUN,
   "irn" :country/IRN,
   "dji" :country/DJI,
   "tg" :country/TGO,
   "jm" :country/JAM,
   "mexico" :country/MEX,
   "are" :country/ARE,
   "ellice islands" :country/FSM,
   "faroe islands" :country/FRO,
   "congo, the democratic republic of the" :country/COD,
   "bhr" :country/BHR,
   "ht" :country/HTI,
   "ethiopia" :country/ETH,
   "egy" :country/EGY,
   "macau" :country/MAC,
   "united states virgin islands" :country/VIR,
   "rw" :country/RWA,
   "ls" :country/LSO,
   "nicaragua" :country/NIC,
   "blr" :country/BLR,
   "mco" :country/MCO,
   "mwi" :country/MWI,
   "md" :country/MDA,
   "ts" :country/TUN,
   "mmr" :country/MMR,
   "hun" :country/HUN,
   "iceland" :country/ISL,
   "lv" :country/LVA,
   "abw" :country/ABW,
   "lt" :country/LSO,
   "greece" :country/GRC,
   "ago" :country/AGO,
   "ad" :country/AND,
   "somalia" :country/SOM,
   "british honduras" :country/BLZ,
   "ku" :country/KWT,
   "kazakstan" :country/KAZ,
   "cy" :country/CYP,
   "rus" :country/RUS,
   "us virgin islands" :country/VIR,
   "yt" :country/MYT,
   "canada" :country/CAN,
   "senegal" :country/SEN,
   "cb" :country/KHM,
   "ne" :country/NER,
   "lithuania" :country/LTU,
   "quatar" :country/QAT,
   "up" :country/UKR,
   "al" :country/ALB,
   "grl" :country/GRL,
   "socialist federal republic of yugoslavia" :country/FRY,
   "reunion" :country/REU,
   "bailiwick of jersey" :country/JEY,
   "us virgin island" :country/VIR,
   "eastern samoa" :country/ASM,
   "arg" :country/ARG,
   "ireland" :country/IRL,
   "nor" :country/NOR,
   "pw" :country/PLW,
   "tto" :country/TTO,
   "tanzania" :country/TZA,
   "mo" :country/MAR,
   "sr" :country/SUR,
   "saint helena" :country/SHN,
   "zwe" :country/ZWE,
   "malawi" :country/MWI,
   "myanmar" :country/MMR,
   "burma" :country/MMR,
   "federal republic of somalia" :country/SOM,
   "gw" :country/GNB,
   "south yemen" :country/YEM,
   "liechtenstein" :country/LIE,
   "ro" :country/ROU,
   "guyana" :country/GUY,
   "ua" :country/UKR,
   "ecu" :country/ECU,
   "vt" :country/VAT,
   "monaco" :country/MCO,
   "sweden" :country/SWE,
   "holy see (vatican city state)" :country/VAT,
   "pe" :country/PER,
   "cn" :country/COM,
   "chad" :country/TCD,
   "tr" :country/TUR,
   "central african republic" :country/CAF,
   "cz" :country/CZE,
   "bx" :country/BRN,
   "azerbaijan" :country/AZE,
   "federated states of micronesia" :country/FSM,
   "grc" :country/GRC,
   "pacific islands" :country/FSM,
   "gmb" :country/GMB,
   "tkm" :country/TKM,
   "ch" :country/CHE,
   "ghana" :country/GHA,
   "gha" :country/GHA,
   "ci" :country/CIV,
   "mlt" :country/MLT,
   "swe" :country/SWE,
   "montserrat" :country/MSR,
   "aland islands" :country/ALA,
   "jersey" :country/JEY,
   "kampuchea" :country/KHM,
   "alb" :country/ALB,
   "mrt" :country/MRT,
   "bermuda islands" :country/BMU,
   "kr" :country/KOR,
   "it" :country/ITA,
   "johnston island" :country/FSM,
   "myt" :country/MYT,
   "mys" :country/MYS,
   "gg" :country/GEO,
   "nu" :country/NIC,
   "gnq" :country/GNQ,
   "glp" :country/GLP,
   "mv" :country/MDV,
   "hungary" :country/HUN,
   "yugoslavia" :country/FRY,
   "vat" :country/VAT,
   "italy" :country/ITA,
   "bt" :country/BTN,
   "papua new guinea" :country/PNG,
   "hn" :country/HND,
   "holy see" :country/VAT,
   "french polynesia" :country/PYF,
   "by" :country/BDI,
   "south africa" :country/ZAF,
   "pakistan" :country/PAK,
   "ek" :country/GNQ,
   "sau" :country/SAU,
   "thailand" :country/THA,
   "cf" :country/CAF,
   "po" :country/PRT,
   "kazakhstan" :country/KAZ,
   "py" :country/PRY,
   "republic of the sudan" :country/SDN,
   "ps" :country/PSE,
   "republic of moldova" :country/MDA,
   "united states of america virgin island" :country/VIR,
   "bw" :country/BWA,
   "palestinian territory, occupied" :country/PSE,
   "mtq" :country/MTQ,
   "ken" :country/KEN,
   "caf" :country/CAF,
   "deu" :country/DEU,
   "is" :country/ISR,
   "honduras" :country/HND,
   "mongolia" :country/MNG,
   "zaf" :country/ZAF,
   "bs" :country/BHS,
   "lo" :country/SVK,
   "the former yugoslav republic of macedonia" :country/MKD,
   "tj" :country/TJK,
   "benin" :country/BEN,
   "cog" :country/COG,
   "asm" :country/ASM,
   "dr" :country/DOM,
   "algeria" :country/DZA,
   "macedonia" :country/MKD,
   "martinique" :country/MTQ,
   "dz" :country/DZA,
   "sx" :country/SGS,
   "fm" :country/FSM,
   "paraguay" :country/PRY,
   "nc" :country/NCL,
   "cambodia" :country/KHM,
   "bo" :country/BOL,
   "jor" :country/JOR,
   "om" :country/OMN,
   "bmu" :country/BMU,
   "libyan arab jamahiriya" :country/LBY,
   "ky" :country/CYM,
   "andorra" :country/AND,
   "vi" :country/VIR,
   "sn" :country/SGP,
   "vn" :country/VNM,
   "russia" :country/RUS,
   "rwanda" :country/RWA,
   "macedonia (republic)" :country/MKD,
   "irq" :country/IRQ,
   "american samoa" :country/ASM,
   "gq" :country/GUM,
   "pry" :country/PRY,
   "lr" :country/LBR,
   "sle" :country/SLE,
   "hong kong" :country/HKG,
   "south georgia and the south sandwich islands" :country/SGS,
   "iq" :country/IRQ,
   "eritrea" :country/ERI,
   "guernsey" :country/GGY,
   "macedonia, former yugoslav republic of" :country/MKD,
   "sc" :country/SYC,
   "san marino" :country/SMR,
   "ax" :country/ALA,
   "bel" :country/BEL,
   "shn" :country/SHN,
   "congo" :country/COG,
   "fji" :country/FJI,
   "id" :country/IDN,
   "pu" :country/GNB,
   "tunisia" :country/TUN,
   "mli" :country/MLI,
   "bermuda" :country/BMU,
   "lka" :country/LKA,
   "china" :country/CHN,
   "cze" :country/CZE,
   "som" :country/SOM,
   "mm" :country/MMR,
   "tls" :country/TLS,
   "bf" :country/BFA,
   "palestinian territories, occupied" :country/PSE,
   "vanuatu" :country/VUT,
   "cj" :country/CYM,
   "panama" :country/PAN,
   "sy" :country/SYR,
   "seychelles" :country/SYC,
   "ic" :country/ISL,
   "tw" :country/TWN,
   "tf" :country/ATF,
   "imn" :country/IMN,
   "guinea-bissau" :country/GNB,
   "uk" :country/GBR,
   "cr" :country/CRI,
   "bosnia-herzegovina" :country/BIH,
   "tt" :country/TTO,
   "rq" :country/PRI,
   "cote d'ivoire" :country/CIV,
   "micronesia, federated states of" :country/FSM,
   "zmb" :country/ZMB,
   "pl" :country/POL,
   "grd" :country/GRD,
   "tl" :country/TLS,
   "vietnam" :country/VNM,
   "my" :country/MYS,
   "er" :country/ERI,
   "co" :country/COL,
   "palestina" :country/PSE,
   "fi" :country/FIN,
   "gs" :country/SGS,
   "south georgia and the south sandwich" :country/SGS,
   "niger" :country/NER,
   "equatorial guinea" :country/GNQ,
   "pan" :country/PAN,
   "burkina faso" :country/BFA,
   "new hebrides" :country/VUT,
   "mb" :country/MTQ,
   "che" :country/CHE,
   "bm" :country/MMR,
   "gt" :country/GTM,
   "georgia (republic)" :country/GEO,
   "mc" :country/MCO,
   "ly" :country/LBY,
   "montenegro" :country/MNE,
   "ltu" :country/LTU,
   "ca" :country/CAN,
   "faeroe islands" :country/FRO,
   "yemen arab republic" :country/YEM,
   "korea, democratic people's republic of" :country/PRK,
   "sv" :country/SLV,
   "si" :country/SVN,
   "vq" :country/VIR,
   "ug" :country/UGA,
   "oman" :country/OMN,
   "mi" :country/MWI,
   "syr" :country/SYR,
   "liberia" :country/LBR,
   "tur" :country/TUR,
   "saint kitts and nevis" :country/KNA,
   "zaire" :country/COD,
   "sierra leone" :country/SLE,
   "sjm" :country/SJM,
   "civ" :country/CIV,
   "khm" :country/KHM,
   "gb" :country/GBR,
   "dnk" :country/DNK,
   "gh" :country/GHA,
   "hr" :country/HRV,
   "argentina" :country/ARG,
   "bih" :country/BIH,
   "reu" :country/REU,
   "persia" :country/IRN,
   "io" :country/IOT,
   "bu" :country/BGR,
   "trinidad" :country/TTO,
   "lby" :country/LBY,
   "gn" :country/GIN,
   "ti" :country/TJK,
   "pol" :country/POL,
   "jre" :country/JEY,
   "lebanon" :country/LBN,
   "republic of the congo" :country/COG,
   "usa" :country/USA,
   "djibouti" :country/DJI,
   "ind" :country/IND,
   "ei" :country/IRL,
   "geo" :country/GEO,
   "united kingdom of great britain and northern ireland" :country/GBR,
   "sl" :country/SLE,
   "cxr" :country/CXR,
   "sa" :country/SAU,
   "mex" :country/MEX,
   "ir" :country/IRN,
   "fr" :country/FRA,
   "kn" :country/KNA,
   "cape verde" :country/CPV,
   "can" :country/CAN,
   "armenia" :country/ARM,
   "bi" :country/BDI,
   "gj" :country/GRD,
   "finland" :country/FIN,
   "nz" :country/NZL,
   "turkmenistan" :country/TKM,
   "slovenia" :country/SVN,
   "falkland islands (malvinas)" :country/FLK,
   "omn" :country/OMN,
   "the democratic republic of the congo" :country/COG,
   "latvia" :country/LVA,
   "lg" :country/LVA,
   "nn" :country/XNN,
   "republic of kosovo" :country/XKS,
   "ma" :country/MAR,
   "smr" :country/SMR,
   "ni" :country/NIC,
   "costa rica" :country/CRI,
   "bénin republic" :country/BEN,
   "united republic of tanzania" :country/TZA,
   "brunei darussalam" :country/BRN,
   "srb" :country/SRB,
   "cyprus" :country/CYP,
   "afg" :country/AFG,
   "tu" :country/TUR,
   "bd" :country/BMU,
   "virgin islands, u.s." :country/VIR,
   "lesotho" :country/LSO,
   "bn" :country/BRN,
   "mk" :country/MKD,
   "bailiwick of guernsey" :country/GGY,
   "eri" :country/ERI,
   "sb" :country/SLB,
   "wa" :country/NAM,
   "arm" :country/ARM,
   "sg" :country/SGP,
   "mda" :country/MDA,
   "ecuador" :country/ECU,
   "cpv" :country/CPV,
   "ms" :country/MSR,
   "af" :country/AFG,
   "cd" :country/COD,
   "kgz" :country/KGZ,
   "cayman islands" :country/CYM,
   "vu" :country/VUT,
   "irl" :country/IRL,
   "gu" :country/GUM,
   "il" :country/ISR,
   "nepal" :country/NPL,
   "norway" :country/NOR,
   "aus" :country/AUS,
   "uganda" :country/UGA,
   "cym" :country/CYM,
   "cmr" :country/CMR,
   "persian empire" :country/IRN,
   "ph" :country/PHL,
   "col" :country/COL,
   "nigeria" :country/NGA,
   "kaz" :country/KAZ,
   "an" :country/AND,
   "eh" :country/ESH,
   "slv" :country/SLV,
   "cri" :country/CRI,
   "sri lanka" :country/LKA,
   "da" :country/DNK,
   "tn" :country/TUN,
   "macedonia, the former yugoslav republic of" :country/MKD,
   "ml" :country/MLI,
   "vnm" :country/VNM,
   "hu" :country/HUN,
   "ez" :country/CZE,
   "yem" :country/YEM,
   "de" :country/DEU,
   "russian federation" :country/RUS,
   "dk" :country/DNK,
   "bahrain" :country/BHR,
   "united kingdom" :country/GBR,
   "am" :country/ARM,
   "mng" :country/MNG,
   "republic of the union of myanmar" :country/MMR,
   "um" :country/UMI,
   "hrv" :country/HRV,
   "namibia" :country/NAM,
   "pp" :country/PNG,
   "former yugoslavia" :country/FRY,
   "sf" :country/ZAF,
   "so" :country/SOM,
   "austria" :country/AUT,
   "switzerland" :country/CHE,
   "kuwait" :country/KWT,
   "ven" :country/VEN,
   "saudi arabia" :country/SAU,
   "kw" :country/KWT,
   "ru" :country/RUS,
   "sk" :country/SVK,
   "iran, islamic republic of" :country/IRN,
   "french southern and antarctic lands" :country/ATF,
   "turkey" :country/TUR,
   "tcd" :country/TCD,
   "mali" :country/MLI,
   "mayotte" :country/MYT,
   "gibraltar" :country/GIB,
   "togo" :country/TGO,
   "mz" :country/MOZ,
   "ala" :country/ALA,
   "trinidad and tobago" :country/TTO,
   "lva" :country/LVA,
   "bosnia and herzegovina" :country/BIH,
   "vir" :country/VIR,
   "east timor" :country/TLS,
   "kz" :country/KAZ,
   "tgo" :country/TGO,
   "ha" :country/HTI,
   "bol" :country/BOL,
   "ga" :country/GAB,
   "pri" :country/PRI,
   "sj" :country/SJM,
   "mus" :country/MUS,
   "ahvenanmaa islands" :country/ALA,
   "united states" :country/USA,
   "kiribati" :country/FSM,
   "isle of man" :country/IMN,
   "pm" :country/PAN,
   "zm" :country/ZMB,
   "gab" :country/GAB,
   "new caledonia" :country/NCL,
   "french southern territories" :country/ATF,
   "virgin islands of the united states" :country/VIR,
   "lh" :country/LTU,
   "swz" :country/SWZ,
   "moz" :country/MOZ,
   "ye" :country/YEM,
   "poland" :country/POL,
   "french polynesian island" :country/PYF,
   "nic" :country/NIC,
   "dj" :country/DJI,
   "british solomon islands" :country/SLB,
   "bh" :country/BLZ,
   "ggy" :country/GGY,
   "mdg" :country/MDG,
   "bv" :country/BVT,
   "united arab emirates" :country/ARE,
   "republic of bulgaria" :country/BGR,
   "albania" :country/ALB,
   "caroline islands" :country/FSM,
   "botswana" :country/BWA,
   "uzbekistan" :country/UZB,
   "uzb" :country/UZB,
   "be" :country/BEL,
   "united states minor outlying islands" :country/UMI,
   "chn" :country/CHN,
   "se" :country/SWE,
   "iraq" :country/IRQ,
   "union of myanmar" :country/MMR,
   "uz" :country/UZB,
   "es" :country/ESP,
   "people's democratic republic of yemen" :country/YEM,
   "iran" :country/IRN,
   "bhs" :country/BHS,
   "ba" :country/BIH,
   "puerto rico" :country/PRI,
   "xks" :country/XKS,
   "micronesia" :country/FSM,
   "uv" :country/BFA,
   "cub" :country/CUB,
   "np" :country/NPL,
   "gf" :country/GUF,
   "nauru" :country/NRU,
   "pse" :country/PSE,
   "former serbia and montenegro" :country/SRB,
   "mar" :country/MAR,
   "ukr" :country/UKR,
   "and" :country/AND,
   "jam" :country/JAM,
   "blz" :country/BLZ,
   "bolivia, plurinational state of" :country/BOL,
   "katar" :country/QAT,
   "ja" :country/JPN,
   "north korea" :country/PRK,
   "ng" :country/NGA,
   "cl" :country/CHL,
   "mt" :country/MLT,
   "ge" :country/GEO,
   "indonesia" :country/IDN,
   "st. kitts and nevis" :country/KNA,
   "gum" :country/GUM,
   "do" :country/DOM,
   "madagascar" :country/MDG,
   "viet nam" :country/VNM,
   "tx" :country/TKM,
   "cu" :country/CUB,
   "fk" :country/FLK,
   "lc" :country/LCA,
   "sz" :country/SWZ,
   "dominican republic" :country/DOM,
   "swaziland" :country/SWZ,
   "rwa" :country/RWA,
   "gtm" :country/GTM,
   "lb" :country/LBN,
   "nam" :country/NAM,
   "guatemala" :country/GTM,
   "new guinea, east" :country/PNG,
   "km" :country/COM,
   "vut" :country/VUT,
   "tha" :country/THA,
   "sdn" :country/SDN,
   "ukraine" :country/UKR,
   "le" :country/LBN,
   "esp" :country/ESP,
   "lao" :country/LAO,
   "gabon" :country/GAB,
   "flk" :country/FLK,
   "qatar" :country/QAT,
   "gbr" :country/GBR,
   "el salvador" :country/SLV,
   "gl" :country/GRL,
   "ae" :country/ARE,
   "jp" :country/JPN,
   "hkg" :country/HKG,
   "za" :country/ZMB,
   "saint lucia" :country/LCA,
   "aj" :country/AZE,
   "fs" :country/ATF,
   "mu" :country/MUS,
   "ner" :country/NER,
   "ben" :country/BEN,
   "et" :country/ETH,
   "bhutan" :country/BTN,
   "hnd" :country/HND,
   "pak" :country/PAK,
   "falkland islands" :country/FLK,
   "ag" :country/DZA,
   "gr" :country/GRC,
   "png" :country/PNG,
   "fg" :country/GUF,
   "kg" :country/KGZ,
   "tm" :country/TKM,
   "ke" :country/KEN,
   "kp" :country/PRK,
   "mx" :country/MEX,
   "ie" :country/IRL,
   "georgia" :country/GEO,
   "svalbard and jan mayen" :country/SJM,
   "ury" :country/URY,
   "bgd" :country/BGD,
   "zimbabwe" :country/ZWE,
   "morocco" :country/MAR,
   "fiji" :country/FJI,
   "ce" :country/LKA,
   "angola" :country/AGO,
   "mr" :country/MSR,
   "ncl" :country/NCL,
   "chl" :country/CHL,
   "mn" :country/MCO,
   "uy" :country/URY,
   "bénin" :country/BEN,
   "virgin islands (u.s.)" :country/VIR,
   "abu dhabi" :country/ARE,
   "gnb" :country/GNB,
   "tza" :country/TZA,
   "rp" :country/PHL,
   "stp" :country/STP,
   "jamaica" :country/JAM,
   "cs" :country/CRI,
   "romania" :country/ROU,
   "svk" :country/SVK,
   "lux" :country/LUX,
   "tc" :country/ARE,
   "aut" :country/AUT,
   "kenya" :country/KEN,
   "no" :country/NOR,
   "syrian arab republic" :country/SYR,
   "guadeloupe" :country/GLP,
   "cv" :country/CPV,
   "malta" :country/MLT,
   "mw" :country/MWI,
   "npl" :country/NPL,
   "gv" :country/GIN,
   "guy" :country/GUY,
   "guadeloupe island" :country/GLP,
   "tajikistan" :country/TJK,
   "ahvenanmaa" :country/ALA,
   "united states of america" :country/USA,
   "barbados" :country/BRB,
   "colombia" :country/COL,
   "estonia" :country/EST,
   "guam" :country/GUM,
   "croatia" :country/HRV,
   "spain" :country/ESP,
   "fin" :country/FIN,
   "tjk" :country/TJK,
   "jordan" :country/JOR,
   "republic of serbia" :country/SRB,
   "kt" :country/CXR,
   "french guiana" :country/GUF,
   "uga" :country/UGA,
   "timor-leste" :country/TLS,
   "christmas island" :country/CXR,
   "sh" :country/SHN,
   "ivory coast" :country/CIV,
   "cyp" :country/CYP,
   "sanaa" :country/YEM,
   "solomon islands" :country/SLB,
   "bc" :country/BWA,
   "lbn" :country/LBN,
   "eg" :country/EGY,
   "union of burma" :country/MMR,
   "benin republic" :country/BEN,
   "re" :country/REU,
   "são tomé and príncipe" :country/STP,
   "republic of korea" :country/KOR,
   "guf" :country/GUF,
   "ar" :country/ARG,
   "ho" :country/HND,
   "sp" :country/ESP,
   "sgs" :country/SGS,
   "bg" :country/BGR,
   "maldives" :country/MDV,
   "germany" :country/DEU,
   "per" :country/PER,
   "bb" :country/BRB,
   "sd" :country/SDN,
   "mdv" :country/MDV,
   "gi" :country/GIB,
   "btn" :country/BTN,
   "tuvalu" :country/FSM,
   "moldova, republic of" :country/MDA,
   "eth" :country/ETH,
   "muscat" :country/OMN,
   "syria" :country/SYR,
   "republic of macedonia" :country/MKD,
   "nld" :country/NLD,
   "grenada" :country/GRD,
   "slovakia" :country/SVK,
   "plw" :country/PLW,
   "sao tome and principe" :country/STP,
   "su" :country/SDN,
   "guinea" :country/GIN,
   "the gambia" :country/GMB,
   "singapore" :country/SGP,
   "north yemen" :country/YEM,
   "qat" :country/QAT,
   "netherlands" :country/NLD,
   "serbia" :country/SRB,
   "fra" :country/FRA,
   "côte d'ivoire" :country/CIV,
   "haiti" :country/HTI,
   "cx" :country/CXR,
   "ve" :country/VEN,
   "bahamas" :country/BHS,
   "egypt" :country/EGY,
   "sgp" :country/SGP,
   "atf" :country/ATF,
   "taiwan" :country/TWN,
   "bangladesh" :country/BGD,
   "fo" :country/FRO,
   "kosovo" :country/XKS,
   "lca" :country/LCA,
   "french polynesian islands" :country/PYF,
   "na" :country/NAM,
   "libya" :country/LBY,
   "nga" :country/NGA,
   "macao" :country/MAC,
   "new zealand" :country/NZL,
   "to" :country/TGO,
   "palestinian territory" :country/PSE,
   "esh" :country/ESH,
   "ita" :country/ITA,
   "gib" :country/GIB,
   "mauritania" :country/MRT,
   "burundi" :country/BDI,
   "lso" :country/LSO,
   "gp" :country/GLP,
   "mauritius" :country/MUS,
   "pa" :country/PRY,
   "mq" :country/MTQ,
   "mg" :country/MNG,
   "fsm" :country/FSM,
   "cuba" :country/CUB,
   "lie" :country/LIE,
   "iot" :country/IOT,
   "yemen" :country/YEM,
   "peru" :country/PER,
   "jo" :country/JOR,
   "rou" :country/ROU,
   "netherlands antilles" :country/XNN,
   "lao people's democratic republic" :country/LAO,
   "sen" :country/SEN,
   "kwt" :country/KWT,
   "jpn" :country/JPN,
   "tz" :country/TZA,
   "aden" :country/YEM,
   "czech republic" :country/CZE,
   "isr" :country/ISR,
   "th" :country/THA,
   "uae - united arab emirates" :country/ARE,
   "nzl" :country/NZL,
   "denmark" :country/DNK,
   "democratic yemen" :country/YEM,
   "montserrat island" :country/MSR,
   "brb" :country/BRB,
   "je" :country/JEY,
   "sm" :country/SMR,
   "wz" :country/SWZ,
   "va" :country/VAT,
   "umi" :country/UMI,
   "as" :country/ASM,
   "korea, republic of" :country/KOR,
   "isl" :country/ISL,
   "portugal" :country/PRT,
   "sudan" :country/SDN,
   "greenland" :country/GRL,
   "palau" :country/PLW,
   "republic of yemen" :country/YEM,
   "ks" :country/KOR,
   "pr" :country/PRI,
   "mozambique" :country/MOZ,
   "est" :country/EST,
   "me" :country/MNE,
   "at" :country/AUT,
   "chile" :country/CHL,
   "vm" :country/VNM,
   "gd" :country/GRD,
   "fj" :country/FJI,
   "sur" :country/SUR,
   "li" :country/LIE,
   "cm" :country/CMR,
   "au" :country/AUS,
   "gy" :country/GUY,
   "bolivia" :country/BOL,
   "vatican city" :country/VAT,
   "bj" :country/BEN,
   "pk" :country/PAK,
   "syc" :country/SYC,
   "trucial states" :country/ARE,
   "brunei" :country/BRN,
   "zi" :country/ZWE,
   "ns" :country/SUR,
   "bra" :country/BRA,
   "lu" :country/LUX,
   "comoros" :country/COM,
   "ao" :country/AGO,
   "tp" :country/STP,
   "bvt" :country/BVT,
   "com" :country/COM,
   "israel" :country/ISR,
   "qa" :country/QAT,
   "philippines" :country/PHL,
   "mp" :country/MUS,
   "united states virgin island" :country/VIR,
   "in" :country/IND,
   "zambia" :country/ZMB,
   "luxembourg" :country/LUX,
   "nr" :country/NRU,
   "fro" :country/FRO,
   "bulgaria" :country/BGR,
   "az" :country/AZE,
   "south korea" :country/KOR,
   "twn" :country/TWN,
   "laos" :country/LAO,
   "mariana islands" :country/FSM,
   "people's republic of serbia" :country/SRB,
   "aruba" :country/ABW,
   "france" :country/FRA,
   "mf" :country/MYT,
   "aze" :country/AZE,
   "kyrgyzstan" :country/KGZ,
   "uruguay" :country/URY,
   "lk" :country/LKA})

(def inverse-country-map
  (map-by country-map val key))

(def inverse-country-sense-map
  (map-by country-sense-map-base val key))

(def inverse-term-map
  (merge inverse-country-map
         {:age/in-utero ["http://vocab.drevidence.com/DocSearch#InUtero"]
          :age/newborn ["http://vocab.drevidence.com/DocSearch#Newborn"]
          :age/infant ["http://vocab.drevidence.com/DocSearch#Infant"]
          :age/child ["http://vocab.drevidence.com/DocSearch#Child"]
          :age/adolescent ["http://vocab.drevidence.com/DocSearch#Adolescent"]
          :age/adult ["http://vocab.drevidence.com/DocSearch#Adult"]
          ;; :age/young-adult ["http://vocab.drevidence.com/DocSearch#YoungAdult"]
          :age/elderly ["http://vocab.drevidence.com/DocSearch#Elderly"]
          :gender/male ["http://vocab.drevidence.com/DocSearch#Female"]
          :gender/female ["http://vocab.drevidence.com/DocSearch#Male"]}))

(def sense-map
  (merge country-sense-map
         {"SUGhHB" :age/in-utero
          "SUFMq" :age/newborn
          "S0FMq" :age/newborn
          "SUFMX" :age/infant
          "SUB98" :age/child
          "SUYr" :age/adolescent
          "SUaM" :age/adult
          ;; "SU6QH" :age/young-adult
          "SUcB" :age/elderly
          "S1cB" :age/elderly
          "SUVI3" :gender/male
          "SUVEQ" :gender/female}))

(def inverse-sense-map
  (merge inverse-country-sense-map
         {:age/in-utero ["SUGhHB"]
          :age/newborn ["SUFMq"]
          :age/infant ["SUFMX"]
          :age/child ["SUB98"]
          :age/adolescent ["SUYr"]
          :age/adult ["SUaM"]
          ;; :age/young-adult ["SU6QH"]
          :age/elderly ["SUcB"]
          :gender/male ["SUVI3"]
          :gender/female ["SUVEQ"]}))

(def term-map
  (merge gender-map age-map country-map us-map))

(def tag-migration-map
  {:company/hoffmann-la-roche "hoffmann-la roche"
   :company/merck-co "merck & co."
   :company/janssen-biotech "janssen biotech"
   :company/bristol-myers-squibb "bristol-myers squibb"
   :company/pfizer "pfizer"
   :company/celgene "celgene"
   :company/novartis "novartis"
   :company/glaxosmithkline "glaxosmithkline"
   :company/regeneron "regeneron"
   :company/merck-group "merck group"
   :company/genentech "genentech"
   :company/astrazeneca "astrazeneca"
   :country/CH "china"
   :country/JA "japan"
   :country/KS "south korea"
   :country/TW "taiwan"
   :country/MC "macao"
   :country/HK "hongkong"
   :country/AR "argentina"
   :country/BR "brazil"
   :country/IN "india"
   :country/ID "indonesia"
   :country/MX "mexico"
   :country/PL "poland"
   :country/SF "south africa"
   :country/TU "turkey"
   :country/Russian-Federation "russia"
   :country/US "united states"
   :country/FR "france"
   :country/UK "united kingdom"
   :country/NI "nigeria"
   :country/SP "spain"
   :country/SZ "switzerland"
   :country/AUS "australia"
   :gender/female "female"
   :gender/male "male"
   :age/child "child"
   :age/adolescent "adolescent"
   :age/elderly "elderly"
   :age/adult "adult"
   :age/infant "infant"
   :age/in-utero "in utero"
   :age/newborn "newborn"})

(def adhoc-types
  {"SUIH2e" ["Demographics"],
   "SUBU-w" ["Demographics"],
   "SGLAm" ["Condensates"],
   "S0Bb24" ["Demographics"],
   "SUGgkC" ["Condensates"],
   "S0BrX4" ["Condensates"],
   "SUEvG" ["Condensates"],
   "SUOltM" ["Condensates"],
   "SGLLH" ["Condensates"],
   "SUE27" ["Demographics"],
   "SUFy04" ["Condensates"],
   "SGLP3" ["Condensates"],
   "SGMFJ" ["Condensates"],
   "SGMEi" ["Condensates"],
   "SGLR6" ["Condensates"],
   "SGK6U" ["Condensates"],
   "SUCiQ" ["Condensates"],
   "SUEzGh" ["Condensates"],
   "SGMPB" ["Condensates"],
   "SUCmiO" ["Demographics"],
   "S0JE8" ["Demographics"],
   "SGMPV" ["Condensates"],
   "SUKPQ" ["Demographics"],
   "SUCLv" ["Demographics"],
   "SU6Rq" ["Demographics"],
   "SGMDJ" ["Condensates"],
   "SUNek_" ["Condensates"],
   "S0BRKz" ["Condensates"],
   "SUBYI" ["Demographics"],
   "SGMYa" ["Condensates"],
   "SUVGK" ["Demographics"],
   "SUFytZ" ["Demographics"],
   "SUGUd" ["Demographics"],
   "SGMEL" ["Condensates"],
   "SGLe-" ["Condensates"],
   "SU6bJ" ["Demographics"],
   "S1Fj3" ["Demographics"],
   "SUCnEZ" ["Demographics"],
   "S0FcE" ["Demographics"],
   "SU6rU" ["Demographics"],
   "SUB26" ["Condensates"],
   "SUVRh" ["Demographics"],
   "SUOkzL" ["Condensates"],
   "SGLqW" ["Condensates"],
   "SUF756" ["Demographics"],
   "SUFMX" ["Demographics"],
   "SUNVGe" ["Condensates"],
   "SGLD5" ["Condensates"],
   "SUVDP" ["Condensates"],
   "SUkz4" ["Demographics"],
   "SUBSeP" ["Demographics"],
   "S0JN3" ["Demographics"],
   "S0Fj3" ["Demographics"],
   "SUJ92W" ["Condensates"],
   "SUXUqC" ["Condensates"],
   "SUDU8M" ["Condensates"],
   "SUBE-t" ["Demographics"],
   "SGK5R" ["Condensates"],
   "SGLOW" ["Condensates"],
   "SUFyGq" ["Demographics"],
   "SGLOK" ["Condensates"],
   "SUBRfP" ["Condensates"],
   "SUGMa" ["Demographics"],
   "SUCmiX" ["Demographics"],
   "SUUwgR" ["Demographics"],
   "SUBU-T" ["Demographics"],
   "SUE29" ["Demographics"],
   "SUEzGM" ["Condensates"],
   "SUC3ll" ["Condensates"],
   "SUB98" ["Demographics"],
   "SUFMq" ["Demographics"],
   "SUF0Fm" ["Demographics"],
   "S1FMB" ["Demographics"],
   "SGLwC" ["Condensates"],
   "SUEV7m" ["Condensates"],
   "SUBSeG" ["Demographics"],
   "SUIT8" ["Demographics"],
   "SUVEQ" ["Demographics"],
   "SUVRf" ["Demographics"],
   "S4B0i" ["Demographics"],
   "SUIGZ" ["Demographics"],
   "SUQKCB" ["Condensates"],
   "SUTSN" ["Demographics"],
   "SUIx7" ["Demographics"],
   "SU7Ox" ["Condensates"],
   "SUCmCA" ["Demographics"],
   "SGLd1" ["Condensates"],
   "SUBSeo" ["Demographics"],
   "SUGi8l" ["Demographics"],
   "SGMSL" ["Condensates"],
   "SUBt4B" ["Demographics"],
   "SUFzlT" ["Condensates"],
   "SUCq1P" ["Demographics"],
   "SUKZz" ["Demographics"],
   "SUDYxm" ["Condensates"],
   "SGLQv" ["Condensates"],
   "S1FcE" ["Demographics"],
   "SUEa8n" ["Condensates"],
   "S1Bb24" ["Demographics"],
   "S0FMB" ["Demographics"],
   "SU4TE" ["Condensates"],
   "SUE68" ["Demographics"],
   "SUKgeZ" ["Condensates"],
   "SUGuw" ["Demographics"],
   "SUBSeY" ["Demographics"],
   "SUUwno" ["Condensates"],
   "S0FMq" ["Demographics"],
   "S0IbP" ["Demographics"],
   "SUBSew" ["Demographics"],
   "SU66k" ["Demographics"],
   "SUVtEs" ["Demographics"],
   "SGMII" ["Condensates"],
   "SUMDQZ" ["Condensates"],
   "SUFlT" ["Demographics"],
   "SUHnV" ["Demographics"],
   "SU69x" ["Demographics"],
   "SGK1Y" ["Condensates"],
   "SUIH2f" ["Demographics"],
   "S0Jst" ["Demographics"],
   "SUBScI" ["Demographics"],
   "SUFAyg" ["Demographics"],
   "SUF7Pj" ["Demographics"],
   "SUFw6D" ["Condensates"],
   "SUCm_E" ["Demographics"],
   "SUGVkR" ["Condensates"],
   "SGMBw" ["Condensates"],
   "SUVIB" ["Demographics"],
   "S1yFc" ["Condensates"],
   "SUIGQ" ["Demographics"],
   "SGLXV" ["Condensates"],
   "SGMGU" ["Condensates"],
   "SUcB" ["Demographics"],
   "SUBRNO" ["Condensates"],
   "SU6QP" ["Demographics"],
   "SUBSeE" ["Demographics"],
   "SUUwiR" ["Demographics"],
   "S1Kal" ["Demographics"],
   "SUrlU" ["Demographics"],
   "S2IbP" ["Demographics"],
   "SGLn3" ["Condensates"],
   "S1G8J" ["Demographics"],
   "SUQO4j" ["Demographics"],
   "SUU79" ["Demographics"],
   "SUXUqD" ["Condensates"],
   "SUGrT_" ["Condensates"],
   "SUYr" ["Demographics"],
   "S0Kal" ["Demographics"],
   "SUF0B5" ["Condensates"],
   "SUID0" ["Demographics"],
   "SUN9II" ["Condensates"],
   "SUGhHB" ["Demographics"],
   "SUFy9E" ["Demographics"],
   "SUEc8H" ["Condensates"],
   "SUJ1h" ["Demographics"],
   "SGMKM" ["Condensates"],
   "SUGXu" ["Demographics"],
   "SUUhkz" ["Condensates"],
   "SUmd" ["Demographics"],
   "SGK-H" ["Condensates"],
   "SU-V" ["Demographics"],
   "SGFjz" ["Demographics"],
   "SUBSeh" ["Demographics"],
   "S0Dq4" ["Demographics"],
   "SUJfo" ["Condensates"],
   "SGMCz" ["Condensates"],
   "SGNZ3" ["Demographics"],
   "SU6QO" ["Demographics"],
   "SUJ-y" ["Demographics"],
   "SUJAw" ["Demographics"],
   "SGMmz" ["Condensates"],
   "SGL8d" ["Condensates"],
   "SGKtc" ["Condensates"],
   "SGLHq" ["Condensates"],
   "SUG-s" ["Condensates"],
   "SUCMQj" ["Demographics"],
   "SUBak" ["Demographics"],
   "SUEc8G" ["Condensates"],
   "SGMa1" ["Condensates"],
   "SUVHV" ["Demographics"],
   "SUVOh" ["Demographics"],
   "SU6QM" ["Demographics"],
   "SGLCz" ["Condensates"],
   "S1Bsts" ["Demographics"],
   "S2B0i" ["Demographics"],
   "SUKf8a" ["Condensates"],
   "SUVJoc" ["Condensates"],
   "SUIiS" ["Demographics"],
   "SGLvx" ["Condensates"],
   "SUBjS" ["Condensates"],
   "SUCmHX" ["Condensates"],
   "SGLFM" ["Condensates"],
   "S1Jst" ["Demographics"],
   "SGFOS" ["Demographics"],
   "SUDnx3" ["Demographics"],
   "SU7Ik" ["Demographics"],
   "SUB3W" ["Condensates"],
   "SUDG9f" ["Demographics"],
   "SUFDod" ["Condensates"],
   "S0G8J" ["Demographics"],
   "SUBtru" ["Condensates"],
   "SUHIX" ["Demographics"],
   "S0FZv" ["Demographics"],
   "SUEc85" ["Condensates"],
   "S3Jst" ["Demographics"],
   "SUBn2Q" ["Demographics"],
   "SUCABx" ["Demographics"],
   "SUCRhn" ["Demographics"],
   "SU6nG" ["Demographics"],
   "SUEve" ["Demographics"],
   "SU6Xl" ["Demographics"],
   "SU7MN" ["Demographics"],
   "SUVI3" ["Demographics"],
   "SUaM" ["Demographics"],
   "SUCmlU" ["Demographics"],
   "SUMeqg" ["Condensates"],
   "SGKsn" ["Condensates"],
   "S5Ro2" ["Condensates"],
   "SUMIH7" ["Demographics"],
   "SU7IQ" ["Demographics"],
   "SUIT0" ["Demographics"]})

(def docsearch-tags-map
  "Map TUI (4 letters) to DocSearch Tag - 3 letters.
   TUI is - Type Unique identifier from UMLS vocabulary."
  {"Condensates" "CON"
   "Demographics" "DEM"
   "T061" "THE"
   "T087" "GEN"
   "T088" "GEN"
   "T028" "GEN"
   "T085" "GEN"
   "T086" "GEN"
   "T045" "GEN"
   "T020" "DIS"
   "T190" "DIS"
   "T049" "DIS"
   "T019" "DIS"
   "T047" "DIS"
   "T050" "DIS"
   "T046" "DIS"
   "T048" "DIS"
   "T191" "DIS"
   "T037" "INJ"
   "T184" "SYM"
   "T116" "CHE"
   "T123" "CHE"
   "T122" "CHE"
   "T103" "CHE"
   "T120" "CHE"
   "T104" "CHE"
   "T196" "CHE"
   "T126" "CHE"
   "T131" "CHE"
   "T125" "CHE"
   "T129" "CHE"
   "T130" "CHE"
   "T197" "CHE"
   "T114" "CHE"
   "T109" "CHE"
   "T192" "CHE"
   "T121" "DRU"
   "T200" "DRU"
   "T127" "VIT"
   "T195" "ANT"
   "T005" "VIR"
   "T025" "CEL"
   "T026" "CEL"
   "T043" "CEL"
   "T017" "ANA"
   "T029" "ANA"
   "T023" "ANA"
   "T030" "ANA"
   "T031" "ANA"
   "T022" "ANA"
   "T018" "ANA"
   "T021" "ANA"
   "T024" "ANA"
   "T203" "MED"
   "T074" "MED"
   "T075" "MED"
   "T007" "BAC"
   "T011" "SPE"
   "T008" "SPE"
   "T194" "SPE"
   "T012" "SPE"
   "T204" "SPE"
   "T013" "SPE"
   "T004" "SPE"
   "T016" "SPE"
   "T015" "SPE"
   "T001" "SPE"
   "T002" "SPE"
   "T014" "SPE"
   "T010" "SPE"
   "T060" "DIA"
   "T059" "LAB"
   "T063" "MOL"
   "T058" "PRO"
   "T062" "PRO"
   "T201" "PHY"
   "T041" "PHY"
   "T044" "PHY"
   "T032" "PHY"
   "T040" "PHY"
   "T042" "PHY"
   "T039" "PHY"
   "T038" "BIO"
   "T069" "PHE"
   "T068" "PHE"
   "T070" "PHE"
   "T067" "PHE"
   "T034" "TST"
   "T093" "ORG"
   "T092" "ORG"
   "T094" "ORG"
   "T095" "ORG"
   "T091" "OCC"
   "T090" "OCC"
   "T168" "FOD"})
